import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { IAtmosConfig } from '../schema';
import { atmosConstants } from '..';

export const useAtmosConfig = () =>
  useQuery<IAtmosConfig[]>({
    queryKey: [atmosConstants.queryKeys.ATMOS_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/atmos/config');

      return res?.data?.data;
    }
  });
